import { TypeTable } from '../../../table/table.component.tsx';
import { DICT_SLOT_PLACEHOLDER_KEY } from '../../states/dictionary.state.ts';

export const viewRows: TypeTable['viewRows'] = {
  action: ({ row }) => {
    // Placeholder rows in limited (slot-mode) dictionaries get a dedicated
    // class so the empty-slot affordance reads at a glance — see WA-3506.
    if (row?.[DICT_SLOT_PLACEHOLDER_KEY]) return 'emptySlot';
    return 'row';
  },
  styles: [
    {
      className: 'row',
      rowStyles: {
        '& .button': {
          display: 'none',
          transition: '0.3s',
        },
        '&:hover .button': {
          display: 'flex',
        },
        '&.MuiDataGrid-row.Mui-selected .button': {
          display: 'flex',
        },
      },
    },
    {
      className: 'emptySlot',
      rowStyles: {
        cursor: 'pointer',
        // Hide row-level action buttons on placeholder rows — there is
        // nothing to act on yet. Save/Delete only make sense once the user
        // has filled the slot with a value.
        '& .button': { display: 'none' },
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      },
    },
  ],
};
